// Sentry is disabled. Keep a no-op client so existing error-handling calls remain safe.
const sentry = {
  captureEvent: () => undefined,
  captureException: () => undefined,
  captureMessage: () => undefined,
  setTag: () => undefined,
  setUser: () => undefined
}

export default sentry
